import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ProjectCsatAdded } from 'api/notifications/meta';
import { Rate } from 'components/atoms/rate';
import { Strong } from '../basics';
import { Causer } from './causer';
import { Content } from './content';

export const ProjectCsatAddedMessage: FC<{ meta: ProjectCsatAdded }> = ({
  meta: { by, milestone },
}) => (
  <FormattedMessage
    id="notifications.messages.project_csat_added"
    values={{
      causer: <Causer user={by} />,
      milestone: <Strong>{milestone}</Strong>,
    }}
  />
);

export const ProjectCsatAddedInfo: FC<{ meta: ProjectCsatAdded }> = ({
  meta: { rating, comment },
}) => {
  return (
    <>
      <Rate disabled defaultValue={rating} />
      {comment != null && (
        <Content data={`<strong><em>${comment}</em></strong>`} />
      )}
    </>
  );
};
